import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { useTranslate } from "helpers";
import { InvoiceItemsAddedProps } from "./types";

import InvoiceItemsAddedChild from "./ItemsAddedChild";
import { FLEET_VEHICLE_INVOICE_ITEMS_CHILD_SEARCH_COLUMNS, FLEET_VEHICLE_INVOICE_ITEMS_SEARCH_COLUMNS } from "./consts";


const InvoiceItemsAdded: React.FC<InvoiceItemsAddedProps> = (props) => {
  const {
    items,
    isLoading,
    onEditClick,
    onDeleteClick
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_INVOICE_ITEMS_SEARCH_COLUMNS(t, onEditClick, onDeleteClick)}
        data={items}
        isLoading={isLoading}
        selectableRows={false}
        columnsChild={FLEET_VEHICLE_INVOICE_ITEMS_CHILD_SEARCH_COLUMNS(t)}
        CustomTableRowChild={InvoiceItemsAddedChild}
      />
    </>
  );
};
export default memo(InvoiceItemsAdded);
